export default {
  data() {
    return {
    }
  },
  methods: {
    getUserPermissionLevel() {
      let accounts = this.$store.getters["accounts/getAccounts"];
      let accountId = this.$route.params.id;

      // If no permissions are found for the given account, 100 should lock anything that needs permissions
      let value = 100;
      accounts.some(account => {
        if (account.accountId == accountId) {
          value = account.permissionLevel;
          return true; // Found, aborts search
        }
      })
      return value;
    },
    getMaxPermissionLevel() {
      let accounts = this.$store.getters["accounts/getAccounts"];

      // If no permissions are found for any account, 100 should lock anything that needs permissions
      let value = 100;
      accounts.some(account => {
        if (value > account.permissionLevel) {
          value = account.permissionLevel;
          if (value == 20) {
            return true; // Is a Treasurer, nothing higher will be found
          }
        }
      })
      return value;
    },
  }
}
